export default "__VITE_ASSET__56c9defa__"